export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function overrideSettings( defaultSettings, overrides ){
  let settings = {
    ...defaultSettings
  };
  if ( overrides === null || overrides === undefined ) return settings;
  for ( const [ prop, value ] of Object.entries( overrides ) ){
    if ( settings && settings.hasOwnProperty( prop ) ){
      if ( typeof value === 'object' && value !== null && !Array.isArray(value)){
        settings[prop] = overrideSettings( defaultSettings[prop], overrides[prop] );
      }
      else{
        settings[prop] = overrides[prop];
      }
    }
    else{
      settings[prop] = overrides[prop];
    }
  }
  return settings;
}
